<template>
  <div class="box" :class="objectClass" style="min-height: 370px">
    <slot></slot>

    <p class="speedee-bold font-size-sm">{{ data.name }}</p>
    <p v-html="data.address" style="min-height: 35px"></p>

    <hr />

    <p>
      <img class="img-fluid" src="@/assets/images/icon-operating.png" style="max-width: 12%" />
      Operation hours
      <font-awesome-icon :icon="icon" class="mr-2 chevron-icon pt-1" @click="handleClick1"></font-awesome-icon>

      <a class="mr-2" :href="data.phone" target="_blank">
        <img class="img-fluid" src="@/assets/images/icon-contact.png" style="max-width: 12%" />
      </a>

      <a :href="data.location" target="_blank">
        <img class="img-fluid" src="@/assets/images/icon-direction.png" style="max-width: 12%" />
      </a>
    </p>
    <div class="text" :class="contentClass">
      <div v-for="(content, conIndex) in data.content" :key="conIndex" class="inside-content">
        <span>{{ content.days }}</span>
        <span>{{ content.hours }}</span>
      </div>
    </div>

    <hr />

    <div v-show="data.deliver">
      <p>
        <img class="img-fluid" src="@/assets/images/icon-delivery.png" style="max-width: 12%" />
        Delivery
        <font-awesome-icon :icon="icon2" class="mr-2 chevron-icon pt-1"
          @click="handleClick2"></font-awesome-icon>
      </p>
      <div class="text" :class="deliveryClass">
        <div v-for="(content, conIndex) in data.content2" :key="conIndex" class="inside-content">
          <span>{{ content.days }}</span>
          <span>{{ content.hours }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  name: 'ContactBox',
  inheritAttrs: false,
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: ''
    },

    icon2: {
      type: String,
      default: ''
    },

    contentClass: {
      type: Object,
      default: {}
    },

    deliveryClass: {
      type: Object,
      default: {}
    },

    objectClass: {
      type: Object,
      default: {}
    },

    modalId: {
      type: String,
      default: ''
    },

    dataTitle: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleClick1() {
      this.$emit('click1');
    },
    handleClick2() {
      this.$emit('click2');
    },
  }
};
</script>

<style>
.box-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
}

.inside-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 30px;
  padding-left: 30px;
}

.box {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  padding: 15px;
}

.box-expanded {
  height: auto;
}

.box-closed {
  height: 100%;
}

.hidden {
  display: none;
}

@media (max-width: 1141px) {
  .box-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 1141px) {
  .box-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 574px) {
  .box-container {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }
}

@media screen and (max-width: 573px) {
  .box-container {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .box-container {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
  }
}

@media screen and (max-width: 287px) {
  .box-container {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
  }
}
</style>